import { render, staticRenderFns } from "./NfseDropdownOptions.vue?vue&type=template&id=596b2215&scoped=true&"
import script from "./NfseDropdownOptions.vue?vue&type=script&lang=js&"
export * from "./NfseDropdownOptions.vue?vue&type=script&lang=js&"
import style0 from "./NfseDropdownOptions.vue?vue&type=style&index=0&id=596b2215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b2215",
  null
  
)

export default component.exports